import { createSlice } from '@reduxjs/toolkit';
import { getItemTypes, getPricingPoints, getRescalingSupportedItemTypes } from './itemApi';
import mappedItemTypes from 'services/items/mappedItemTypes';

const initialState = {
    itemTypes: [],
    dataForItemCreation: [],
    rescalingSupportedItemTypes: [],
    itemTypesWithWeatherZones: [mappedItemTypes.WIND_ASSET.id],
};

const itemSlice = createSlice({
    name: 'items',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getItemTypes.fulfilled, (state, action) => {
                state.itemTypes = action.payload;
            })
            .addCase(getPricingPoints.fulfilled, (state, action) => {
                state.dataForItemCreation = action.payload;
            })
            .addCase(getRescalingSupportedItemTypes.fulfilled, (state, action) => {
                state.rescalingSupportedItemTypes = action.payload;
            });
    },
});

export default itemSlice.reducer;
